import { apiWrapper } from "@/services/api";

export const getNotifications = async () => {
  try {
    let url = `electric_bulletin_board.json`;

    const timestamp = new Date().getTime();
    url += `?${timestamp}`; // キャッシュ対策

    const resp = await apiWrapper(
      "GET",
      url,
      null,
      false,
      false,
      "Notification"
    );

    return resp.data;
  } catch (err) {
    console.log("ERROR!!! getNotifications");
    throw err;
  }
};
